import React, { PropsWithChildren } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../lib/utils';

const PopoverRoot = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverContent = PopoverPrimitive.Content;
const PopoverPortal = PopoverPrimitive.Portal;

export interface PopoverProps extends PropsWithChildren {
  contentClassName?: string;
  contentAlign?: React.ComponentProps<typeof PopoverContent>['align'];
  disabled?: boolean;
  trigger: React.ReactNode;
  popoverProps?: React.ComponentProps<typeof PopoverRoot>;
}
const Popover = ({
  contentClassName,
  contentAlign = 'start',
  trigger,
  children,
  disabled,
  popoverProps,
}: PopoverProps) => {
  return (
    <PopoverRoot {...popoverProps} data-test-id="dropdown-menu">
      <PopoverTrigger disabled={disabled} asChild>
        {trigger}
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          align={contentAlign}
          sideOffset={6}
          onOpenAutoFocus={e => e.preventDefault()}
          className={cn(
            'bg-background z-50 min-w-[8rem] overflow-hidden rounded-md border border-border p-1 text-popover-foreground shadow-lg',
            'origin-[var(--radix-popover-content-transform-origin)] duration-150',
            'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 w-[var(--radix-popper-anchor-width)]',
            contentClassName
          )}
        >
          {children}
        </PopoverContent>
      </PopoverPortal>
    </PopoverRoot>
  );
};

export default Popover;
